// Fixed reference catalogs (OperationType, FuelType, MeasurementType) are seeded identically
// across every tenant, but the API returns their names in whatever language the tenant was
// seeded in. So the portal translates them by id on the client (same approach as the app),
// instead of showing the raw DB name. Unknown/new ids fall back to the provided name.

const OPERATION_TYPE_KEYS = {
    1: 'opAddStock',
    2: 'opRemoveStock',
    3: 'opAcquisition',
    4: 'opAdjustment',
    5: 'opWaste',
    6: 'opDefect',
    7: 'opLoss',
    8: 'opStockTransfer',
    9: 'opTank',
    10: 'opHarvest',
    11: 'opConsumed',
    12: 'refillVehicle',
    13: 'refillTank',
    14: 'adjustReading',
    15: 'gasStationFill',
    16: 'evCharge',
};

const FUEL_TYPE_KEYS = {
    1: 'fuelTypeAgrDiesel',
    2: 'fuelTypeDiesel',
    3: 'fuelTypeGasoline',
    4: 'fuelTypeGpl',
    5: 'fuelTypeElectric',
};

const MEASUREMENT_TYPE_KEYS = {
    1: 'measureUnit',
    2: 'measureLiquid',
    3: 'measureWeight',
};

const label = (map, translate, id, fallback) => {
    const key = map[Number(id)];
    if (key) return translate(key);
    return fallback != null && fallback !== '' ? fallback : '-';
};

export const operationTypeLabel = (translate, id, fallback) =>
    label(OPERATION_TYPE_KEYS, translate, id, fallback);

export const fuelTypeLabel = (translate, id, fallback) =>
    label(FUEL_TYPE_KEYS, translate, id, fallback);

export const measurementTypeLabel = (translate, id, fallback) =>
    label(MEASUREMENT_TYPE_KEYS, translate, id, fallback);
